export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/error_generic-926eb3e0fc2c252e612f1392fedb8c07.svg";